import { superCall as _$su, className as _$cn, extend as _$ex, EMPTY_OBJ as _$em, createElementVNode as _$ce, noop as _$no, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Button } from '../button';
import { Icon } from '../icon';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    closable = _this$get.closable,
    type = _this$get.type,
    disabled = _this$get.disabled;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-tip"] = true, _classNameObj[makeStyles(k)] = true, _classNameObj);
  return _$su.call($this, {
    'className': _$cn(classNameObj),
    'name': 'k-fade'
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['body'] = function ($super) {
      return _$ce(2, 'div', [$blocks.title ? _$ce(2, 'div', (_$blocks['title'] = function ($super) {
        return null;
      }, __$blocks['title'] = function ($super, data) {
        var block = $blocks['title'];
        var callBlock = function callBlock() {
          return _$blocks['title'].call($this, $super, data);
        };
        return block ? block.call($this, callBlock, data) : callBlock();
      }, __$blocks['title'](_$no)), 0, _$cn(k + "-tip-title")) : undefined, children], 0, _$cn(k + "-tip-wrapper"));
    }, __$blocks['body'] = function ($super, data) {
      var block = $blocks['body'];
      var callBlock = function callBlock() {
        return _$blocks['body'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), (_$blocks['_close'] = function ($super) {
      return closable ? _$cc(Button, {
        'type': !$blocks.close ? 'none' : 'link',
        'icon': !$blocks.close,
        'ev-click': this.onClose,
        'className': _$cn(k + "-tip-close"),
        'children': (_$blocks['close'] = function ($super) {
          return _$cc(Icon, {
            'className': _$cn(k + "-icon-close"),
            'hoverable': !disabled
          });
        }, __$blocks['close'] = function ($super, data) {
          var block = $blocks['close'];
          var callBlock = function callBlock() {
            return _$blocks['close'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }, __$blocks['close'](_$no))
      }) : undefined;
    }, __$blocks['_close'] = function ($super, data) {
      var block = $blocks['_close'];
      var callBlock = function callBlock() {
        return _$blocks['_close'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;